import type { ArCellValue } from '#types/System.Artifacts.types';

type SplitQueryKeyAndLabel = {
  key: string | null;
  label: string;
};

/**
 * Derives a stable string key (used for filtering) and a human label (used for UI)
 * from an ArTable/Table cell value.
 */
function getSplitQueryKeyAndLabel(value: ArCellValue | unknown): SplitQueryKeyAndLabel {
  if (value === null || value === undefined) return { key: null, label: '' };

  if (typeof value === 'string') return { key: value, label: value };

  if (typeof value === 'number' || typeof value === 'boolean') {
    const s = String(value);
    return { key: s, label: s };
  }

  if (typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const docId = typeof obj.docId === 'string' ? obj.docId : undefined;
    const cacheLabel = typeof obj.cacheLabel === 'string' ? obj.cacheLabel : undefined;
    const key = docId ?? cacheLabel ?? null;
    const label = cacheLabel ?? docId ?? '';
    return { key, label };
  }

  return { key: null, label: '' };
}

export { getSplitQueryKeyAndLabel };

